export default "__VITE_PUBLIC_ASSET__b9614229__"